const styles = {
  container: {
    position: 'absolute',
    top: '5vh',
    paddingLeft: '3em',
  },
  separation: {
    display: 'block',
    marginTop: '1em',
    marginBottom: '1em',
  },
  spanBold: {
    fontWeight: 'bold',
  }
};

export default styles;
